import React from 'react';
import cx from 'classnames';
import { Tooltip } from '../Global/Tooltip';
import { useTranslation } from 'react-i18next';
import './Legend.scss';

// TODO legends need to be dynamic, based on current page AND current teacher selections

export default function Legend(props) {
    const {direction} = props;
    const {t} = useTranslation("reports");
    const legendWrapperClasses = cx({
      'legendWrapper': true,
      'row': direction === 'row',
    })

    const legendClasses = cx({
      'legend': true,
      'row': direction === 'row',
    })
    return (
      <div className={legendWrapperClasses}>
        <div className="reportsAdditionalSelectionTitle">LEGEND</div>
        <div className={legendClasses}>
          {props.items.map(({icon, colorBlockClass, blockColor, text, tooltipType}, i) => {
            let blockClass = cx({
              'legendItemBlock': true,
              'bad': (colorBlockClass == "bad"),
              'great': (colorBlockClass == "great"),
              'average': (colorBlockClass == "average"),
            })

            let blockStyles = {};
            if(blockColor) blockStyles.background = blockColor

            return (
              <div className="legendItem" key={i}>
                <div className={blockClass} style={blockStyles}>
                  {icon && <img className="icon" src={icon} alt=""/>}
                </div>
                <div>
                  {t(text)}
                  {!!tooltipType && <Tooltip type={tooltipType} />}
                </div>
              </div>
            )
          })}
        </div>
      </div>
    );
}